/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HubSpotEnrollmentRow } from './hubSpotEnrollmentRow';

/**
 * Courses to enroll, each with optional extraModuleIds on that row
 */
export type HubSpotEnrollRequestEnrollments = HubSpotEnrollmentRow[] | null;
